<template>
  <Transition>
    <slot />
  </Transition>
</template>

<style scoped>
.v-enter-active {
  transition: opacity 0.12s ease-in;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
